﻿import { Component, Input, Output, EventEmitter, ElementRef, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { Subject } from 'rxjs';
import { Observable } from "rxjs";
import { DomSanitizer } from "@angular/platform-browser";
import * as _ from "lodash";
import { of } from 'rxjs';
import { map,  catchError } from 'rxjs/operators';
import * as moment from 'moment';
import { ValidationMessage } from "../validation/validationMessage";
import { ValidationMessageType } from "../validation/validationMessageType";
import { DataService } from "../services/dataService";
import { ValidationBase } from "../validation/validationBase";
import { Department } from "../models/department.model";

@Component({
    selector: "jax-blockcase",
    templateUrl: "./blockcase.component.html",
    host: { "(document: keyup)": "keyup($event)" }
})

export class BlockCaseComponent extends ValidationBase {
    public iNotifyError;
    public data;
    public caseNumber: string;
    private userId: number;
    private currentUser: any;
    public departments: Department[] = [];
    public blockCase: any = {};
    public todayDate: string;
    public users = [];
    public isCustomValid: boolean;
    public validationMessage: ValidationMessage;
    public hasSuccess: boolean;

    public namehasError: boolean;
    public nameErrorMessage: string;
    public departmenthasError: boolean;
    public departmentErrorMessage: string;
    public reasonhasError: boolean;
    public reasonErrorMessage: string;

    


    @ViewChild("sendBlockRequest") sendRequest: any;
    @ViewChild("userName") userNameElement: any;
    @ViewChild("caseNumber") caseNumberElement: any;
    @ViewChild("sdate") startDateElement: any;
    @ViewChild("edate") endDateElement: any;
    


    constructor(private dataService: DataService, private router: Router, private sanitizer: DomSanitizer) {
        super();
        this.iNotifyError = this;
    }

    public ngOnInit() {
        this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
        if (this.currentUser) {
            this.userId = this.currentUser.UserId;
        }

    }

    public ngAfterViewInit(){
        this.clearSearch();
        this.GetDepartment();
    }

    public observableSourceUser = (keyword: any): Observable<any[]> => {
        let url: string = "user/searchusername?nameLiteral=" + keyword;
        if (keyword) {
            return this.dataService.get(url)
                .map(res => {
                    let json = res;
                    return json;
                });
        } else {
            return of([]);
        }
    }


    private keyup(event: KeyboardEvent): void {
        if (event.keyCode === 13) {
            this.sendBlockCaseRequest();
        }
    }

    public sendBlockCaseRequest() {
        let d = this.blockCase.department;
        this.validateAllCustom();
        this.validate()
            .subscribe((s) => {
                if (!this.isValid || !this.isCustomValid)
                    return;

                this.validationMessage = null;
                let message = new ValidationMessage();

                if (this.blockCase.department!=null) {
                    this.blockCase.department = this.blockCase.department.value || this.blockCase.department;
                }

                if (this.blockCase.name != null) {
                    if (typeof this.blockCase.name == "object") {
                        this.blockCase.name = this.blockCase.name.LastName + "," + this.blockCase.name.FirstName;
                    }
                }

                this.dataService.post("casemanager/requestblockcase", JSON.stringify(this.blockCase))
                    .subscribe((response) => {
                            if (response.Succeeded == 2) {
                                this.hasSuccess = true;
                                message.messageType = ValidationMessageType.Ok;
                            } else {
                                this.hasSuccess = false;
                                message.messageType = ValidationMessageType.Error;
                            }
                            message.message = response.Message;
                            this.validationMessage = message;
                        },
                        error => {
                            this.hasSuccess = false;
                            message.message = error.message;
                            message.messageType = ValidationMessageType.Error;
                            this.validationMessage = message;
                        });
            });
    }

    public autocompleListFormatter = (data: any) => {
        let html = `<span>${data.value}</span>`;
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }

    public autocompleListFormatterUsers = (data: any) => {
        let html = `<span>${data.LoginName} - ${data.value}</span>`;
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }


    private GetDepartment() {
        this.dataService.get("common/departments").subscribe(resp => {
            let dept = resp;
            this.departments = dept;
            this.blockCase.department = "";
        });
    }

    public onchangeuser(event) {
        if (event) {
            this.blockCase.loginName = event.LoginName;
            this.blockCase.department = event.Department!=null ? event.Department.value:"";
        }
    }

    public getUserDetail(event) {

        this.blockCase.name = "";
        this.blockCase.department = "";

        if (this.blockCase.loginName) {

            this.dataService.get("user/getuser?loginName=" + this.blockCase.loginName).subscribe(resp => {
                let userdetail = resp;
                if (userdetail) {
                    this.blockCase.name = userdetail.LastName + "," + userdetail.FirstName;
                    this.blockCase.department = userdetail.Department.value;
                    this.userNameElement.hasError = false;
                    this.userNameElement.errorMessage = "";
                    this.namehasError = false;
                    this.nameErrorMessage = "";
                    this.departmenthasError = false;
                    this.departmentErrorMessage = "";
                } else {
                    this.isCustomValid = false;
                    this.userNameElement.hasError = true;
                    this.userNameElement.errorMessage = "Invalid user name";
                }
            });
        }
    }

    public validateCaseNumber() {
        if (this.blockCase.CaseNumbers) {
            this.dataService.get("Cases/IsValidCaseNumber?caseNumber=" + this.blockCase.CaseNumbers).subscribe(resp => {
                let isValid = resp;
                if (!isValid) {
                    this.isCustomValid = false;
                    this.caseNumberElement.hasError = true;
                    this.caseNumberElement.errorMessage = "Invalid case number";
                } else {
                    this.caseNumberElement.hasError = false;
                    this.caseNumberElement.errorMessage = "";
                }
            });
        }
    }

    public validateDate() {
        if (this.blockCase.startDate) {

            this.startDateElement.hasError = false;
            this.startDateElement.errorMessage = "";
            this.endDateElement.hasError = false;
            this.endDateElement.errorMessage = "";
            if (this.blockCase.endDate && this.blockCase.startDate > this.blockCase.endDate) {
                this.isCustomValid = false;
                this.startDateElement.hasError = true;
                this.startDateElement.errorMessage = "Start date cannot be grater then End date";
                this.endDateElement.hasError = true;
                this.endDateElement.errorMessage = "Start date cannot be grater then End date";
            } 
        }
    }

    public validateName() {
        if (!this.blockCase.name) {
            this.isCustomValid = false;
            this.namehasError = true;
            this.nameErrorMessage = "Name is required";
        } else {
            this.namehasError = false;
            this.nameErrorMessage = "";
        }
    }

    public validateDepartment() {
        if (!this.blockCase.department) {
            this.isCustomValid = false;
            this.departmenthasError = true;
            this.departmentErrorMessage = "Department is required";
        } else {
            let i = this.departments.findIndex(d => d.value == this.blockCase.department);
            if (i >= 0) {
                this.departmenthasError = false;
                this.departmentErrorMessage = "";
            } else {
                this.isCustomValid = false;
                this.departmenthasError = true;
                this.departmentErrorMessage = "Invalid department, please select the department from the list";
            }
        }
    }

    public validateReason() {
        if (!this.blockCase.blockReason) {
            this.reasonhasError = true;
            this.reasonErrorMessage = "Reason is required";
            this.isCustomValid = false;
        } else {
            this.reasonhasError = false;
            this.reasonErrorMessage = "";
        }
    }

    public validateAllCustom() {
        this.isCustomValid = true;
        this.validateCaseNumber();
        this.validateDate();
        this.validateDepartment();
        this.validateName();
        this.validateReason();
    }

    public clearSearch() {
        this.isCustomValid = true;

        this.todayDate = moment(new Date()).format("YYYY-MM-DD");
        this.blockCase.startDate = this.todayDate;
        this.blockCase.endDate = this.todayDate;

        this.blockCase.loginName = "";
        this.blockCase.name = "";
        this.blockCase.department = "";
        this.blockCase.blockReason = "";
        this.blockCase.CaseNumbers = "";
        this.data = "";

        this.namehasError = false;
        this.nameErrorMessage = "";
        this.departmenthasError = false;
        this.departmentErrorMessage = "";
        this.reasonhasError = false;
        this.reasonErrorMessage = "";

        this.caseNumberElement.hasError = false;
        this.caseNumberElement.errorMessage = "";

        this.userNameElement.hasError = false;
        this.userNameElement.errorMessage = "";

        this.startDateElement.hasError = false;
        this.startDateElement.errorMessage = "";
        this.endDateElement.hasError = false;
        this.endDateElement.errorMessage = "";
    }



}